import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/modal';
import { Button } from '@/components/ui/button';
import { ModalProps } from '@/hooks/use-modal';

export type EmptyDescriptionScope = 'project' | 'member' | 'entry';

interface EmptyDescriptionInfoModalProps extends ModalProps {
  scope: EmptyDescriptionScope;
}

export function EmptyDescriptionInfoModal({
  open,
  onOpen,
  onClose,
  scope,
}: EmptyDescriptionInfoModalProps) {
  const { t } = useTranslation('authenticated.timeTracking');

  const messageKey =
    scope === 'project'
      ? 'approvals.emptyDescription.infoModal.messageProject'
      : scope === 'member'
        ? 'approvals.emptyDescription.infoModal.messageMember'
        : 'approvals.emptyDescription.infoModal.messageEntry';

  return (
    <Modal open={open} onOpen={onOpen} onClose={onClose} className="w-[460px] shadow-xl">
      <div className="mb-4 flex items-center gap-2.5">
        <AlertTriangle className="h-5 w-5 flex-shrink-0 text-warning" strokeWidth={1.8} />
        <Modal.Title className="mb-0 text-[20px] font-bold leading-tight tracking-tight">
          {t('approvals.emptyDescription.infoModal.title')}
        </Modal.Title>
      </div>

      <Modal.Body>
        <p className="text-sm leading-[1.55] text-foreground">{t(messageKey)}</p>
      </Modal.Body>

      <Modal.Footer className="mt-5">
        <Button onClick={onClose}>{t('approvals.emptyDescription.infoModal.close')}</Button>
      </Modal.Footer>
    </Modal>
  );
}
